import axios from "axios";
import config from "../../config";
import Cookies from "js-cookie";

const baseUrl = config.baseUrl; // URL base de tu API
const baseEnpoint = "/api/users";

// Crear una instancia de Axios con la configuración base
const api = axios.create({
  baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const uploadFirmaUsuario = async (idUsuario, name, role, numeroCedula, signatureBase64) => {
  if (!idUsuario) throw new Error("id_usuario es requerido");
  if (!signatureBase64) throw new Error("Firma es requerida");

  // base64 → Blob → File (lo que espera multer con el campo "archivo")
  const [meta, b64] = signatureBase64.split(",");
  const mimeType = meta.match(/:(.*?);/)[1];
  const byteString = atob(b64);
  const arrayBuffer = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    arrayBuffer[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([arrayBuffer], { type: mimeType });
  const firmaFile = new File(
    [blob],
    `firma_user_${idUsuario}.png`,
    { type: mimeType }
  );

  const formData = new FormData();
  formData.append("id_usuario", String(idUsuario));
  formData.append("name", name);
  formData.append("role", role);
  formData.append("numero_cedula", String(numeroCedula));
  formData.append("archivo", firmaFile); // campo que espera multer

  // ⚠️ NO declarar Content-Type — axios lo pone solo con el boundary correcto
  const response = await api.post( `${baseEnpoint}/firma`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
};
